export default __webpack_public_path__ + "static/media/Weltkarte.9d2f4a3d.jpg";